<!-- 抄自 oam -->
<template>
<div class="update_password_holder" :class="{ active: showUpdatePassword }">
  <div class="update_password_overlay" @click="closeForm()"></div>
  <div class="update_password">
    <div class="update_password_title"> 修改密碼 </div>
    <div class="update_password_colse" @click="closeForm()">
      <i class="el-icon-close"></i>
    </div>
    <div class="update_password_wrapper" ref="update_password_wrapper">
      <div class="update_password_content">
        <el-form
          :model="updatePasswordForm"
          status-icon :rules="rules"
          ref="updatePasswordForm"
          label-width="120px"
          @submit.prevent.native="submitForm('updatePasswordForm')">
          <el-form-item prop="oldpw">
            <template #label>
              <span class='requireSign'>＊</span>
              <span>當前密碼</span>
            </template>
            <el-input type="password" :show-password="true" v-model.trim="updatePasswordForm.oldpw"></el-input>
          </el-form-item>
          <el-form-item prop="newpw">
            <template #label>
              <span class='requireSign'>＊</span>
              <span>輸入新密碼</span>
            </template>
            <el-input type="password" :show-password="true" v-model.trim="updatePasswordForm.newpw" placeholder="最短8個字，包含至少一個大寫英文字母、小寫英文字母、數字" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item prop="confirmpw">
            <template #label>
              <span class='requireSign'>＊</span>
              <span>確認新密碼</span>
            </template>
            <el-input type="password" :show-password="true" v-model.trim="updatePasswordForm.confirmpw" placeholder="兩次輸入須一致" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item class="btns_action">
            <el-button @click="closeForm()">放棄修改</el-button>
            <el-button
              native-type="submit"
              type="primary"
              :disabled="!isValid">確定
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import rootApi from '@/api/root.js'
import {
  regexPassword
} from '@/utils/password'
export default {
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        this.isValid = false
        callback(new Error('欄位輸入不完整'))
      } else if (!regexPassword(value)) {
        this.isValid = false
        callback(new Error('密碼須包含至少一個大寫英文字母、小寫英文字母、數字'))
      } else if (value.length < 8) {
        this.isValid = false
        callback(new Error('密碼最短8個字'))
      } else {
        if (this.updatePasswordForm.confirmpw !== '') {
          this.$refs.updatePasswordForm.validateField('confirmpw')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        this.isValid = false
        callback(new Error('欄位輸入不完整'))
      } else if (value !== this.updatePasswordForm.newpw) {
        this.isValid = false
        callback(new Error('新密碼兩次輸入須一致'))
      } else {
        this.isValid = true
        callback()
      }
    }
    return {
      isValid: false,
      updatePasswordForm: {
        newpw: '',
        confirmpw: '',
        oldpw: ''
      },
      rules: {
        newpw: [
          { validator: validatePass, trigger: 'blur' }
        ],
        confirmpw: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState('root', ['showUpdatePassword'])
  },
  methods: {
    ...mapActions('root', ['setShowUpdatePassword']),
    submitForm () {
      this.$refs['updatePasswordForm'].validate((valid) => {
        if (valid) {
          rootApi.updatePassword(this.updatePasswordForm)
            .then(() => {
              this.closeForm()
              this.$message.success('密碼已修改')
            })
            .catch(() => {
              this.$message.error('原密碼輸入錯誤')
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeForm () {
      this.resetForm()
      this.setShowUpdatePassword(false)
    },
    resetForm () {
      this.$refs['updatePasswordForm'].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/styles/z-index.scss';
  @import '@/styles/global.scss';
  .requireSign {
    color: rgba(255,0,0,0.87);
    font-size: 10px;
  }
  .update_password_holder {
  .update_password:last-of-type {
    transform: translate(100vw, 0);
  }
  &.active {
    .update_password_overlay {
      visibility: visible;
      opacity: .6;
    }
    .update_password {
      transform: translate(0, 0);
      max-width: 768px;
    }
  }
  .update_password_overlay {
    opacity: 0;
    visibility: hidden;
    position: fixed;
    top: map-get($globalVariable, HeaderHeight);
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #4a4a4a;
    transition: all, .3s;
    z-index: map-get($z-index, UpdatePasswordOverlay);
  }
  .update_password_colse {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    font-size: 40px;
    transition: all, .3s;
    cursor: pointer;
    &:hover {
      color: #555;
    }
  }
  .update_password {
    position: fixed;
    top: map-get($globalVariable, HeaderHeight);
    right: 0;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    background-color: #ffffff;
    transition: translate, .3s;
    z-index: map-get($z-index, UpdatePasswordOverlay);
    .update_password_title {
      position: absolute;
      top: 10px;
      left: 50%;
      font-size: 24px;
      color: #4A4A4A;
      transform: translate(-50%);
    }
    .update_password_wrapper {
      overflow-x: hidden;
      overflow-y: auto;
      position: fixed;
      top: 40px;
      right: 0;
      bottom: 0;
      width: 100%;
      max-width: 100%;

    }
    .update_password_wrapper .update_password_content {
      padding: 73px 40px 0 40px;
      label {
        margin-top: 15px;
        .label_title {
          text-align: right;
          font-size: 14px;
          color: #4A4A4A;
          span:first-child {
            color: rgba(255,0,0,0.87);
          }
        }
      }
      .btns_action {
        margin-top: 15px;
        .btn {
          margin-left: 5px;
          width: 110px;
          text-align: center;
        }
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
      .error_text {
        padding-left: 115px;
        margin: 5px 0;
        font-size: 14px;
        color: #D0021B;
      }
    }
  }
}

</style>
